import type React from "react";
import { useState } from "react";

import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { BaseButton } from "shared/atoms/BaseButton";
import { MUIUnifiedModal } from "shared/atoms/MUIUnifiedModal";

interface Props {
  content?: string;
}

export const ICDWarningPopup: React.FC<Props> = ({ content }) => {
  const [isOpen, setOpen] = useState(true);
  const { t } = useTranslation();
  return isOpen ? (
    <MUIUnifiedModal open={isOpen} onClose={() => setOpen(false)} showCloseButton={false} width="360px">
      <Content>
        {content}
        <BaseButton text={t("buttons.ok")} onClick={() => setOpen(false)} />
      </Content>
    </MUIUnifiedModal>
  ) : null;
};

const Content = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  padding: 16px;
  gap: 20px;
`;
